import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//Dashboard
import Dashboard from "./dashboard/reducer"

// client
import Client from "./client/reducer"
// lead
import Lead from "./lead/reducer"
// brand
import Brand from "./brand/reducer"
// model
import Model from "./model/reducer"
// vehicle
import Vehicle from "./vehicle/reducer"

// lead history
import LeadHistory from "./leadhistory/reducer"
// varient
import Varient from "./varient/reducer"
// sale
import Sale from "./sale/reducer"
// users
import Members from "./users/reducer"
// lead notes
import LeadNotes from "./leadnotes/reducer"

import ExcelDownload from "./excelDownload/reducer"

import Categories from "./categories/reducer"

import FollowUp from "./followUp/reducer"

import MatchList from "./matchlist/reducer"

import Inspection from "./inspection/reducer"
import Branches from "./branches/reducer"

import Challan from "./challan/reducer"
import Testimonial from "./Testimonial/reducer"
import YoutubeVideo from "./YoutubeVideos/reducer"
import YoutubeShortVideo from "./YoutubeShortVideos/reducer"
import CarDelivery from "./CarDelivery/reducer"
import Showroom from "./Showrooms/reducer"
import Banner from "./Banner/reducer"
import InvestmentLead from "./investment-lead/reducer"
import Summary from "./summary/reducer"
import Settings from "./settings/reducer"


const rootReducer = combineReducers({
  Challan,
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Dashboard,
  Client,
  Lead,
  Brand,
  Model,
  Vehicle,
  LeadHistory,
  Varient,
  Sale,
  Members,
  LeadNotes,
  ExcelDownload,
  Categories,
  FollowUp,
  MatchList,
  Inspection,
  Testimonial,
  YoutubeVideo,
  YoutubeShortVideo,
  CarDelivery,
  Showroom,
  Banner,
  Branches,
  InvestmentLead,
  Summary,
  Settings
})

export default rootReducer
